import loadMailboxAutomaticRepliesConfiguration from '../services/loadMailboxAutomaticRepliesConfiguration';
import parseMailboxAutoReplyConfiguration from '../utils/parseMailboxAutoReplyConfiguration';
import updateAutomaticRepliesInitialState from '../data/mutators/updateAutomaticRepliesInitialState';
import { trace } from 'owa-trace';

export default async function initLoadMailboxAutomaticRepliesConfiguration() {
    try {
        let mailboxAutoReplyConfiguration = await loadMailboxAutomaticRepliesConfiguration();
        // update optionsState with values from mailboxAutoReplyConfiguration
        updateAutomaticRepliesInitialState(
            parseMailboxAutoReplyConfiguration(mailboxAutoReplyConfiguration)
        );
        return true;
    } catch (e) {
        trace.warn(e.message || 'initLoadMailboxAutomaticRepliesConfiguration failed');
        return false;
    }
}
